import { Box, Tab, Tabs } from '@mui/material';

export interface PestanaDrawerSvcc {
    valor: number;
    etiqueta: string;
    deshabilitada?: boolean;
}

interface Props {
    valor: number;
    onCambio: (evento: React.SyntheticEvent, nuevoValor: number) => void;
    pestanas: PestanaDrawerSvcc[];
}

/**
 * Pestañas internas de un drawer del SVCC, como píldoras numeradas en una barra
 * redondeada: el mismo lenguaje que los pasos del informe (`Tab.tsx`). Se
 * ponen dentro de `DrawerSvccEncabezado`.
 */
const PestanasDrawerSvcc = ({ valor, onCambio, pestanas }: Props) => (
    <Tabs
        value={valor}
        onChange={onCambio}
        variant="fullWidth"
        sx={{
            minHeight: 0,
            p: 0.5,
            border: '1px solid #E0EBED',
            borderRadius: '12px',
            '& .MuiTabs-indicator': { display: 'none' },
            '& .MuiTabs-flexContainer': { gap: 0.5 }
        }}
    >
        {pestanas.map(({ valor: valorPestana, etiqueta, deshabilitada }, indice) => {
            const activa = valorPestana === valor;
            return (
                <Tab
                    key={valorPestana}
                    value={valorPestana}
                    disabled={deshabilitada}
                    label={
                        <Box display="flex" alignItems="center" gap={1}>
                            <Box
                                component="span"
                                sx={{
                                    width: 22,
                                    height: 22,
                                    borderRadius: '50%',
                                    fontSize: 12,
                                    fontWeight: 700,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    ...(activa
                                        ? { bgcolor: 'primary.main', color: '#FFFFFF' }
                                        : { border: '1.5px solid #6B777C', color: '#3D4A50' })
                                }}
                            >
                                {indice + 1}
                            </Box>
                            {etiqueta}
                        </Box>
                    }
                    sx={{
                        minHeight: 34,
                        py: 0.75,
                        borderRadius: '10px',
                        textTransform: 'none',
                        fontSize: 14,
                        fontWeight: activa ? 700 : 500,
                        color: '#3D4A50',
                        bgcolor: activa ? '#E8F3E6' : 'transparent',
                        '&:hover': { bgcolor: activa ? '#E8F3E6' : '#F3F8F8' },
                        '&.Mui-selected': { color: 'primary.main' }
                    }}
                />
            );
        })}
    </Tabs>
);

export default PestanasDrawerSvcc;
